import React, { PropsWithChildren } from 'react';
import { useMinimizedDrawersState } from '../../../shared/hooks/useMinimizedDrawersState';
import { MinimizedDrawersContext } from './MinimizedDrawersContext';

const STORAGE_KEY = 'diamMinimizedDrawersState';

export const MinimizedDrawersProvider: React.FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  const { isLoaded, ...state } = useMinimizedDrawersState(STORAGE_KEY);

  if (!isLoaded) return null;

  return (
    <MinimizedDrawersContext.Provider value={state}>
      {children}
    </MinimizedDrawersContext.Provider>
  );
};
